import { createBaseWorkspaceStore } from '@tickitacka/shared';

export const useWorkspaceStore: ReturnType<typeof createBaseWorkspaceStore> =
    createBaseWorkspaceStore();
